/**
 * The test sites (app.test.pizzafelice.com, admin.test.fusion-eat.com, meals.test.fusion-eat.com) must never be
 * mistaken for the live ones (Maurizio, 2026-10-20). Decided from the address the page is served from, not from the
 * build, so a test build can never pass for live or the other way round.
 */
export const IS_TEST_SITE = /(^|\.)test\./.test(window.location.hostname);

/** The live site's address for this test site ("admin.test.fusion-eat.com" → "admin.fusion-eat.com"). */
export const LIVE_HOST = window.location.hostname.replace(/(^|\.)test\./, "$1");

/** "[TEST] …" in front of the browser tab title on a test site. */
export function markTestTitle() {
  if (IS_TEST_SITE && !document.title.startsWith("[TEST]")) document.title = `[TEST] ${document.title}`;
}
